// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { BarHeader } from 'dibs-elements/exports/BarHeader';
import { ModalBody } from 'dibs-elements/exports/ModalBody';
import { ModalCloseButton } from 'dibs-elements/exports/ModalCloseButton';
import { ModalContainer } from 'dibs-elements/exports/ModalContainer';

import UpdateName from './UpdateName';
import type { UpdateNameProps } from './UpdateName';

const messages = {
    title: (
        <FormattedMessage
            id="dc.ProjectForms.UpdateNameModal.title"
            defaultMessage="Edit Tag Name"
        />
    ),
};

type UpdateNameModalProps = {|
    ...UpdateNameProps,
    isOpen?: boolean,
    onClose: () => void,
|};

export function UpdateNameModal(props: UpdateNameModalProps) {
    const { isOpen, onClose, ...updateNameProps } = props;

    return (
        <ModalContainer isOpen={!!isOpen} modalPosition="center" onClose={onClose}>
            <BarHeader title={messages.title} />
            <ModalCloseButton onClick={onClose} />
            <ModalBody>
                <UpdateName {...updateNameProps} />
            </ModalBody>
        </ModalContainer>
    );
}

export default UpdateNameModal;
